import { render, staticRenderFns } from "./SessionNavBar.vue?vue&type=template&id=52e4eb78"
import script from "./SessionNavBar.vue?vue&type=script&lang=js"
export * from "./SessionNavBar.vue?vue&type=script&lang=js"
import style0 from "./SessionNavBar.vue?vue&type=style&index=0&id=52e4eb78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports